import axios from 'axios';
import React, { useState } from 'react';
import styled from 'styled-components';

const Mail = () => {
  const [emailAddress,setEmailAddress] = useState('');

  const submitMail=(e)=>{
    e.preventDefault();
    axios.post('https://api.bakpoket.com/api/AToZ/NewsLetter-Post',{emailAddress})
    .then(res =>{
      setEmailAddress('')
    })
    .catch(err => console.log(err))
  }
  return (
    <OuterWrapper>
    <Wrapper>
      <img src='/images/newsletter-icon.png' alt='Newsletter Icon' />

      <div className="text-wrapper">
        <p className="bold">Get the best coupons before they expire, straight to your inbox</p>
        <p className="normal">Please subscribe to have new coupon lists delivered directly to your inbox</p>
        <Form onSubmit={submitMail}>
          <input type="email" placeholder='Enter Email Address' value={emailAddress} onChange={(e)=>{setEmailAddress(e.target.value)}}/>
          <button type="submit">SUBMIT</button>
        </Form>
      </div>
    </Wrapper>
  </OuterWrapper>
  );
};

export default Mail;

const OuterWrapper = styled.section`
  background-color: #fff;
  border:2px solid #ef4766;
  padding: 6px 16px;
  display: flex;
  justify-content: center;
  margin-bottom:20px;
  @media (max-width: 480px) {
    padding: 5px 0px;
  }
`;

const Wrapper = styled.section`
  background-color: #fff;
  padding: 0px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1280px;

  img {
    width: 50px;
    height: 50px;
  }

  .text-wrapper {
    display: flex;
    justify-content: space-between;
    flex: 1;
    margin-left:30px;
  }

  .bold {
    font-weight: bold;
    font-size: 18px;
    color: #ef4766;
    margin: auto 0px;
    width:20%;
    text-align: center;
  }

  .normal {
    font-size: 15px;
    color: #ef4766;
    margin: auto  0px;
    width:30%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 0px 3px !important;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    

    .text-wrapper {
      margin-left: 8px !important;
    }
    img {
      width: 44px;
      height: 44px;
      margin-left:0px;
      margin-top:6px;
    }

    .bold {
      font-size: 7px;
      text-align:center;
      margin-left:0px;
      text-align:center;
    }

    .normal {
      font-size: 8px !important;
      margin-top:2px;
      margin-bottom:4px;
      text-align:center;
    }
  }
  @media (max-width: 1107px) {
    flex-direction: row;
    align-items: flex-start;
    padding: 0px 40px;
    gap: 0px;


    img {
      width: 50px;
      height: 50px;
      margin: auto;
    }

    .text-wrapper {
      margin-left: 10px;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      margin-left:20px;
    }

    .bold {
      font-size: 10px;
      margin-top: 0px;
      margin-bottom: 0px;
      width: auto;
      align-item:center;
      display: flex;
    }

    .normal {
      font-size: 10px;
      margin-top:0px;
      width:100%;
    }
  }
  }
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    padding: 0px 40px;
    gap: 0px;


    img {
      width: 50px;
      height: 50px;
      margin: auto;
    }

    .text-wrapper {
      margin-left: 10px;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      margin-left:20px;
    }

    .bold {
      font-size: 10px;
      margin-top: 0px;
      margin-bottom: 0px;
      width: auto;
      align-item:center;
      display: flex;
    }

    .normal {
      font-size: 10px;
      margin-top:0px;
      width:100%;
    }
  }
`;

const Form = styled.form`
  display: flex;
  align-items: center;

  input {
    padding: 10px 12px;
    border: none;
    border-radius: 5px 0 0 5px;
    font-size: 14px;
    width: 250px;
    border: 1px solid #ef4766;
  }

  button {
    padding: 10px 20px;
    border: none;
    background-color: #ef4766;
    color: #fff;
    font-weight: bold;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    transition: background 0.3s;

    // &:hover {
    //   background-color: #333;
    // }
  }

  @media (max-width: 768px) {
  margin-left:5px;
    input {
      width: 120px;
      font-size: 10px;
      padding: 6px 8px;
    }

    button {
      padding: 6px 12px;
      font-size: 10px;
    }
  }

  @media (max-width: 480px) {
    margin: auto;
    input {
      width: 100px;
      font-size: 8px;
      padding: 4px 6px;
      margin-left:0px;
    }

    button {
      padding: 5px 10px;
      font-size: 8px;
    }
  }
`;
